// react
import PropTypes from "prop-types";
import React from "react";

export default class Modal extends React.Component {
	static propTypes = {
		onOK: PropTypes.func,
		onClose: PropTypes.func,
		onCancel: PropTypes.func,
		message: PropTypes.string,
	};

	static defaultProps = {
		message: "",
		onOK: () => {},
		onClose: () => {},
		onCancel: () => {},
	};

	handleClose = () => {
		this.props.onClose();
	};

	handleOK = () => {
		this.props.onOK();
	};

	handleCancel = () => {
		this.props.onCancel();
	};

	render() {
		return (
			<div className="component-modal">
				<div className="modal-head">
					<div onClick={this.handleClose} className="close-box button fa fa-times-circle-o" />
				</div>

				<div className="modal-text">{this.props.message}</div>

				<div className="modal-buttons">
					<>
						<button onClick={this.handleOK} className="newpy button green">
							<div className="fa fa-check" />
						</button>
						<button onClick={this.handleCancel} className="newpy button red">
							<div className="fa fa-times" />
						</button>
					</>
				</div>
			</div>
		);
	}
}
